var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.35759 14.0007H0.247768V4.65379H3.35759V14.0007ZM1.801 3.37879C0.806585 3.37879 0 2.61004 0 1.68191C7.11763e-09 1.2361 0.189748 0.808549 0.527502 0.493312C0.865256 0.178075 1.32335 0.000976562 1.801 0.000976562C2.27866 0.000976562 2.73675 0.178075 3.07451 0.493312C3.41226 0.808549 3.60201 1.2361 3.60201 1.68191C3.60201 2.61004 2.79509 3.37879 1.801 3.37879ZM14.9967 14.0007H11.8935V9.45066C11.8935 8.36629 11.8701 6.97566 10.2767 6.97566C8.65982 6.97566 8.41205 8.15379 8.41205 9.37254V14.0007H5.30558V4.65379H8.28817V5.92879H8.3317C8.74687 5.19441 9.76105 4.41941 11.2741 4.41941C14.4214 4.41941 15 6.35379 15 8.86629V14.0007H14.9967Z",
    fill: "#2B66BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4c8f5cf3.svg";
export { ForwardRef as ReactComponent };